import React from "react";
import Link from "helpers/link";
import Image from "components/image";
import Icon from "@root/_components/Icon/icon";

const DirectLink = ({ data }) => (
    <Link to={data?.url} className="header__nav-link header__nav-item">
        <p className="header__dropdown-title">
            {data.title}
        </p>
    </Link>
);

const ImageLinks = ({ data }) => (
    <div className="header__nav-link header__dropdown">
        {data.directLink.url ? (
            <Link
                to={data.directLink.url}
                className="header__nav-item-hit"
                aria-label={data.directLink.title}
            />
        ) : null}
        <div className="header__dropdown-wrapper">
            <div className="header__dropdown-title">
                {data.directLink.title}
                <div className="header__dropdown-title-sub-chevron-wrapper">
                    <Icon 
                        icon="chevron-right" 
                        className="header__dropdown-title-sub-chevron" 
                        size={17}
                    />
                </div>
            </div>
            <div className="header__dropdown-menu">
                <div className="header__dropdown-items">
                    {data.imageLinkData.map((link) => (
                        <div
                            className="header__dropdown-item"
                            key={link._key}
                        >
                            <div className="header__dropdown-link-wrapper">
                                <Link to={link?.directLink?.url} aria-label={link?.directLink?.title} className="header__dropdown-link">
                                    <Image image={link?.linkImage} width={30} height={30} className="header__dropdown-image" />
                                    <span className="header__dropdown-text">
                                        {link?.directLink?.title}
                                    </span>
                                </Link>
                                {link._type === "imageLinkData" && link.groupLinks && link.groupLinks.length > 0 && (
                                    <div className="header__dropdown-sub-chevron-wrapper">
                                        <Icon 
                                            icon="chevron-right" 
                                            className="header__dropdown-sub-chevron" 
                                            size={24}
                                        />
                                    </div>
                                )}
                            </div>
                            {link._type === "imageLinkData" && link.groupLinks && link.groupLinks.length > 0 && (
                                <div className="header__dropdown-sub-items">
                                    {link.groupLinks.map((groupLink) => (
                                        <div className="header__dropdown-sub-item" key={groupLink._key}>
                                            <Link to={groupLink?.directLink?.url} aria-label={groupLink?.directLink?.title} className="header__dropdown-sub-link">
                                                {groupLink.directLink.title}
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
);
const DesktopHeaderData = ({ data }) => {
    if (!data) return null;

    const LinkType = () => data.map((link) => {
        if (link._type === "directLink") return <DirectLink data={link} key={link._key} />;
        if (link._type === "imageLink") return <ImageLinks data={link} key={link._key} />;

        return null; 
    });

    return <div className="header__nav-links"><LinkType /></div>;
};

export default DesktopHeaderData;
